import { useEffect } from "react";
import { useAppDispatch, useImagePath } from "hooks";
import { onClosePopUp } from "redux/slices";
import CTA from "components/Buttons/ThemeButton";
import { Head, Title, Container } from "./styles";
import { Grid, useMediaQuery } from "@mui/material";
import { useGoogleAnalyticsContext, useWebStoreContext } from "contexts";
import { clubGiftsGaloreAssets } from "assets/cdn";
import { tabletGiftsGaloreView } from "pages/ClubShop/ClubEventSection/lib/GiftsGaloreCard/styles";
import { ClubGiftsGaloreResponse } from "interfaces/club-gifts-galore-v2";
import { featureTrackerAPI } from "redux/apis";
import { FeatureType } from "interfaces/feature-tracker";

interface CGGEarnedRewardProps {}

export const CGGEarnedReward: React.FC<CGGEarnedRewardProps> = () => {
	const dispatch = useAppDispatch();
	const { authToken } = useWebStoreContext();
	const { reportEvent, reportPlaygamiEvent } = useGoogleAnalyticsContext();
	const isMobileSize = useMediaQuery(`(max-width:${tabletGiftsGaloreView})`);
	const { getImage } = useImagePath("cdn");
	const earnedRewardAssets = clubGiftsGaloreAssets.v1.popups.earnedReward;
	const titleDesktop = getImage(earnedRewardAssets.title);
	const titleMobile = getImage(earnedRewardAssets.titleMobile);
	const backgroundMobile = getImage(earnedRewardAssets.backgroundMobile);
	const backgroundDesktop = getImage(earnedRewardAssets.backgroundDesktop);

	const { data }: { data?: ClubGiftsGaloreResponse } =
		featureTrackerAPI.endpoints.getFeatureTracker.useQueryState({
			FeatureType: FeatureType.CLUB_GIFT_BONUS_V2,
			isAuthenticated: !!authToken?.value
		});

	const { tracker } = data ?? {};
	const activeTier = tracker?.tiers[tracker?.activeTierIndex];

	useEffect(() => {
		reportEvent("reward_pop_up", {
			source: "club_gifts_galore"
		});
		reportPlaygamiEvent("tp.web_frontend", {
			event_name: "reward_pop_up",
			event_type: "club_gift_galore_v2",
			action: "reward_pop_up",
			source: "club_gifts_galore",
			event_id: tracker?.id,
			value_int:
				typeof activeTier?.tierIndex === "number"
					? tracker?.userClubTracker.tierContributionCounts[
							activeTier.tierIndex
					  ]
					: undefined,
			confignodecount: activeTier?.maxUserContributionCount,
			progress_status: activeTier?.contributionCount.toString(),
			loopcount: (tracker?.activeTierIndex ?? 0) + 1
		});
	}, []);

	return (
		<Container
			/* isMobile={isMobile} */ background={
				isMobileSize ? backgroundMobile : backgroundDesktop
			}
		>
			<Head>
				<Title src={isMobileSize ? titleMobile : titleDesktop} />
			</Head>
			<Grid container spacing={2} justifyContent="center">
				<Grid item xs={12} md="auto" display="flex" justifyContent="center">
					<CTA
						style={{ width: "220px", fontSize: 20 }}
						onClick={() => {
							dispatch(onClosePopUp());
						}}
					>
						Yay!
					</CTA>
				</Grid>
				{/* {isMobile && (
					<Grid item>
						<BackToGameButton
							source="club_gifts_galore_dialog"
							themeColor="secondary"
							styles={{ width: "220px", fontSize: 20 }}
							onClick={() => {
								dispatch(onClosePopUp());
							}}
						>
							Back to Game
						</BackToGameButton>
					</Grid>
				)} */}
			</Grid>
		</Container>
	);
};
